import React, { FC, useCallback } from 'react';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';

import MessagePlaceholder from '../../ui/Content/Message/MessagePlaceholder';
import Paragraph from '../../ui/Typography/Paragraph';
import HighlightedArea from '../../ui/Content/HighlightedArea';
import Link from '../../ui/Controls/Link';
import Button from '../../ui/Controls/Button';
import { $l } from '../../../locales';
import { SUPPORT_ROUTE } from '../../../config';
import { selectUserId, selectWorkspaceId } from '../../../store/selectors/user';
import { redirectToSupport } from '../../../store/actions/chat';
import { useAppSelector } from '../../../store/hooks';
import { TICKET_CREATED_MESSAGE_ID } from '../../../constants/messages';

interface ICreatedTicket {
  id: number;
  hash?: string;
}

const CreatedTicket: FC<ICreatedTicket> = ({ id, hash }) => {
  const userId = useAppSelector(selectUserId);
  const workspaceId = useAppSelector(selectWorkspaceId);
  const ticketsRoute = `${SUPPORT_ROUTE}/tickets`;
  const ticketLink = `${ticketsRoute}/${id}?${hash ? `hash=${hash}` : ''}`;
  const isSupportPage = window.location.origin === SUPPORT_ROUTE;
  const goToHelpCenter = useCallback(() => {
    redirectToSupport(workspaceId)();
  }, [workspaceId]);

  return (
    <MessagePlaceholder
      icon="colored--40--green-check"
      title={$l('TICKET_HEADER')}
      gap="12"
      indents="24-16"
      id={TICKET_CREATED_MESSAGE_ID}
    >
      <HighlightedArea>
        <Paragraph fontSize="12">
          {$l('TICKET_NUMBER')}{' '}
          <Link href={ticketLink} tag="a" fontSize="12" target="_blank">
            #{id}
          </Link>
        </Paragraph>
        {!!userId && (
          <Paragraph fontSize="12">
            {$l('TRACK_YOUR_STATUS')}{' '}
            <Link href={ticketsRoute} fontSize="12" tag="a" target="_blank">
              {$l('MY_TICKETS')}
            </Link>
          </Paragraph>
        )}
      </HighlightedArea>
      <Paragraph fontSize="12" align="center" className="indent-xs-top">
        {$l('TICKET_TEXT')}
      </Paragraph>
      {!isSupportPage && (
        <Actions width="full" gap="8" direction="column">
          <ActionsItem width="full">
            <Button text={$l('GO_TO_HELP_CENTER')} onClick={goToHelpCenter} />
          </ActionsItem>
        </Actions>
      )}
    </MessagePlaceholder>
  );
};

export default CreatedTicket;
